import React from 'react';
import { Modal, Button, Row, Col, FormGroup } from 'react-bootstrap'
import { Form, TextAreaBox } from 'fw/forms'

class ModalRemove extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			visible: false,
			title: null,
			elementType: null,
			name: null,
			id: null,
			onYes: null,
			onNo: null,
			form: {
				reason: ''
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ visible: nextProps.visible });
	}

	open = (params) => {
		const defaults = {
			title: "Remove item",
			elementType: "item",
			reason: false,
			id: null
		};

		this.setState({
			visible: true,
			...defaults,
			...params
		});
	}

	yes = () => {
		if (this.state.onYes)
			this.state.onYes(this.state.id, this.state.form.reason);

		this.setState(this.initialState());
	}

	no = () => {
		if (this.state.onNo)
			this.state.onNo();

		this.setState(this.initialState());
	}

	handleCommentChange = (form, callback) => {
		this.setState({ form }, callback);
	}

	renderNoReasonModal = () => {
		return (
			<React.Fragment>
				<Modal show={this.state.visible} onHide={this.no} backdrop="static">
					<Modal.Header>
						<Modal.Title>{this.state.title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div dangerouslySetInnerHTML={{ __html: "Are you sure you wish to <strong>delete</strong> the " + this.state.elementType + " <strong><big>" + this.state.name + "</big></strong>?" }} />
					</Modal.Body>
					<Modal.Footer>
						<Button bsStyle="link" onClick={this.no} autoFocus>Cancel</Button>
						<Button bsStyle="danger" onClick={this.yes}>Yes, delete!</Button>
					</Modal.Footer>
				</Modal>
			</React.Fragment>)
	}

	renderReasonModal = () => {
		return (
			<React.Fragment>
				<Modal show={this.state.visible} onHide={this.no} backdrop="static">
					<Form
						values={this.state.form}
						onChange={this.handleCommentChange}
						onSubmit={this.yes}>
						<Modal.Header>
							<Modal.Title>{this.state.title}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Row>
								<Col sm={12}>
									<FormGroup>
										Enter the reason for the deletion
										<TextAreaBox
											name="reason"
											maxLength={256}
											placeholder="Enter your comments here..."
											required />
									</FormGroup>
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<Button bsStyle="link" onClick={this.no} autoFocus>Cancel</Button>
							<Button bsStyle="primary" type="submit">Confirm</Button>
						</Modal.Footer>
					</Form>
				</Modal>
			</React.Fragment>)
	}

	render() {
		return (
			this.state.reason === true ? this.renderReasonModal() : this.renderNoReasonModal()
		)
	}
}

export default ModalRemove;



// WEBPACK FOOTER //
// ./src/fw/modals/remove/Remove.js